import React from "react";
import HeaderOne from "../components/HeaderOne";
import HeroOne from "../components/HeroOne";
import CounterOne from "../components/CounterOne";
import AboutOne from "../components/AboutOne";
import MarqueeOne from "../components/MarqueeOne";
import ClientAreaOne from "../components/ClientAreaOne";
import ProcessAreaOne from "../components/ProcessAreaOne";
import TestimonialsOne from "../components/TestimonialsOne";
import FooterAreaOne from "../components/FooterAreaOne";
import SubscribeOne from "../components/SubscribeOne";
import Preloader from "../helper/Preloader";
import useInitialLoad from "../helper/useInitialLoad";
import { Helmet } from "react-helmet-async";


const HomePageOne = () => {
  const showPreloader = useInitialLoad(2000);

  return (
    <>
      {/* Preloader */}
      {showPreloader && <Preloader />}

      {/* Header one */}
      <HeaderOne />

      <Helmet>
        {/* <!-- Basic SEO tags --> */}
        <title>Leal Chapa y Pintura | Taller Mecánica Sevilla</title>
        <meta name="language" content="Spanish" />
        <meta name="author" content="www.lealchapaypintura.com" />
        <meta
          name="description"
          content="Taller de chapa, pintura y mecánica en Mairena del Aljarafe, Sevilla. +15 años de experiencia. Garantía de por vida. Presupuesto sin compromiso."
        />
        <meta
          name="keywords"
          content="taller chapa pintura Sevilla, mecánica Mairena Aljarafe, reparación coches Sevilla, taller PISA Sevilla, alquiler coches taller"
        />
        <meta name="robots" content="index, follow" />

        {/* <!-- Open Graph tags --> */}
        <meta
          property="og:title"
          content="Leal Chapa y Pintura | Taller Mecánica Sevilla"
        />
        <meta
          property="og:description"
          content="Taller de chapa, pintura y mecánica en Mairena del Aljarafe, Sevilla. +15 años de experiencia. Garantía de por vida."
        />
        <meta property="og:image" content="https://www.lealchapaypintura.com/favicon.png" />
        <meta property="og:url" content="https://www.lealchapaypintura.com" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_ES" />

        {/* <!-- Twitter Card tags --> */}
        <meta
          name="twitter:title"
          content="Leal Chapa y Pintura | Taller Mecánica Sevilla"
        />
        <meta
          name="twitter:description"
          content="Taller de chapa, pintura y mecánica en Mairena del Aljarafe, Sevilla. +15 años de experiencia. Garantía de por vida."
        />
        <meta name="twitter:image" content="https://www.lealchapaypintura.com/favicon.png" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://www.lealchapaypintura.com/" />

        {/* <!-- LocalBusiness Schema --> */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AutoRepair",
            "name": "Leal Chapa y Pintura",
            "image": "https://www.lealchapaypintura.com/favicon.png",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "C. Congreso, 57, Pol. P.I.S.A",
              "addressLocality": "Mairena del Aljarafe",
              "addressRegion": "Sevilla",
              "postalCode": "41927",
              "addressCountry": "ES"
            },
            "telephone": "+34698925394",
            "url": "https://www.lealchapaypintura.com",
            "priceRange": "$$",
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                "opens": "08:00",
                "closes": "19:00"
              }
            ],
            "sameAs": [
              "https://wa.me/+34698925394"
            ]
          })}
        </script>
      </Helmet>
      {/* Hero One */}
      <HeroOne />

      {/* Counter One */}
      <CounterOne />

      {/* About One */}
      <AboutOne />

      {/* Process Area One */}
      <ProcessAreaOne />

      {/* Testimonials One */}
      <TestimonialsOne />

      {/* Marquee One */}
      <MarqueeOne />

      {/* CTA Area One */}
      <ClientAreaOne />
      
      {/* Faq Area One */}
      {/* <ServiceAreaOneMultiImg /> */}
      
      {/* Faq Area One */}
      {/* <FaqAreaOne /> */}

      {/* Subscribe One */}
      <SubscribeOne />

      {/* Footer Area One */}
      <FooterAreaOne />
    </>
  );
};

export default HomePageOne;
